import Card from '@material-ui/core/Card';
import blue from '@material-ui/core/colors/blue';
import deepPurple from '@material-ui/core/colors/deepPurple';
import green from '@material-ui/core/colors/green';
import orange from '@material-ui/core/colors/orange';
import yellow from '@material-ui/core/colors/yellow';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import React, { Fragment,cloneElement, useEffect, useState } from 'react';
import { CreateButton, Datagrid, DateField, List, ShowButton, TextField, TopToolbar, sanitizeListRestProps,useListContext } from 'react-admin';
import FiltreCampagne from '../filtres/FiltreCampagne';
import PostPagination from '../paginations/pagination';
import { has_role,createAutorisation } from '../references';
import rowStyleCampagne from '../styles/rowStyleCampagne';








const style = { marginLeft: 15 }
var total = 0, montant = 0, frais = 0;

//const libele = { fontWeight: 'bold', fontSize: 12 };
const styleNbTotalColis ={
    borderLeftColor: orange[500],
    borderLeftWidth: 4,
    borderLeftStyle: 'solid',
} ;

const styleColisLivre ={
    borderLeftColor: green[500],
    borderLeftWidth: 4,
    borderLeftStyle: 'solid',
} ;

const styleColisRecu ={
    borderLeftColor: yellow[500],
    borderLeftWidth: 4,
    borderLeftStyle: 'solid',
} ;

const styleColisCharge ={
    borderLeftColor: blue[500],
    borderLeftWidth: 4,
    borderLeftStyle: 'solid',
} ;
const styleColisReduction ={
    borderLeftColor: deepPurple[500],
    borderLeftWidth: 4,
    borderLeftStyle: 'solid',
} ;

const CampagnePanel = ({ id, record, resource }) => (
    <Card >
        <Table>
            <TableHead>
		                
                <TableRow >
                    <TableCell style={{fontWeight:'bold',fontSize:14}}>
                        Libelé
                    </TableCell>
                    <TableCell style={{fontWeight:'bold',fontSize:14}}>
                        Statistique
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody key={id}>
                <TableRow key={'colis_livre'}>
                    <TableCell style={styleColisCharge}>Nb colis chargé</TableCell>
                    <TableCell style={styleColisCharge}>{record.nb_colis_charge}</TableCell>
                </TableRow>

                <TableRow key={'colis_non_charge'}>
                    <TableCell style={styleColisCharge}>Nb colis non chargé</TableCell>
                    <TableCell style={styleColisCharge}>{record.nb_colis_non_charge}</TableCell>
                </TableRow>
                <TableRow key={'colis_charge'}>
                    <TableCell style={styleColisRecu}>Nb colis reçu</TableCell>
                    <TableCell style={styleColisRecu}>{record.nb_colis_recep}</TableCell>
                </TableRow>

                <TableRow key={'colis_non_recu'}>
                    <TableCell style={styleColisRecu}>Nb colis non reçu</TableCell>
                    <TableCell style={styleColisRecu}>{record.nb_colis_non_recep}</TableCell>
                </TableRow>
                <TableRow key={'colis_recu'}>
                    <TableCell style={styleColisLivre}>Nb colis livré</TableCell>
                    <TableCell style={styleColisLivre}>{record.nb_colis_livre}</TableCell>
                </TableRow>

                <TableRow key={'colis_restant'}>
                    <TableCell style={styleColisLivre}>Nb colis non livré</TableCell>
                    <TableCell style={styleColisLivre}>{record.nb_colis_non_livre}</TableCell>
                </TableRow>
                <TableRow key={'nb_colis'} >
                    <TableCell style={styleNbTotalColis}>Nb Total colis</TableCell >
                    <TableCell style={styleNbTotalColis}>{record.nb_colis}</TableCell>
                </TableRow>
                <TableRow key={'pourcentage'} >
                    <TableCell style={styleColisReduction}>Pourcentage réduction</TableCell>
                    <TableCell style={styleColisReduction}>{record.prourc_reduct} %</TableCell>
                </TableRow>
                <TableRow key="reduct" >
                    <TableCell style={styleColisReduction}>Réduction</TableCell>
                    <TableCell style={styleColisReduction}>{record.reduction} €</TableCell>
                </TableRow>
            </TableBody>
        </Table>
    </Card>
);

const ListCampagne = (props) => {

    const [fullname, setFullname] = useState('');

    const { permissions } = props;
    useEffect(() => {
        //console.log(props);
        setFullname(localStorage.getItem('fullname'));

    }, []);

    return (
        <List {...props}
            title={'Campagne - '+fullname}
            //bulkActionButtons={<GuetsiBulkActionButtons />}
            actions={<ListActions {...props}/>}
            filters={<FiltreCampagne />}
            pagination={<PostPagination />}
            sort={{ field: 'id', order: 'DESC' }}
            bulkActionButtons={false}

        >

            <Datagrid rowStyle={rowStyleCampagne} optimized expand={<CampagnePanel />}>
                <TextField source="code" label="Code" style={{ color: 'purple' }} sortBy="code" />
                <TextField source="numero" label="Numéro"  sortBy="numero" />
                <TextField source="type" label="Type" sortBy="type" />
                <TextField source="status" label="Status" sortBy="status" />
                <TextField source="adrDep" label="Adresse départ" sortBy="adrDep" />
                <TextField source="adrArr" label="Adresse arrivée" sortBy="adrArr" />
                <DateField source="dateDepart" label="Date départ" sortBy="date_depart" />
                <DateField source="dateArrive" label="Date arrivé" sortBy="date_arrive" />
                <TextField source="initCodeColis" label="Initial code" />
                {has_role(permissions,'ROLE_MANAGER') ?
                <TextField source="reste_a_payer" label="Reste à payer(€)" sortBy="reste_a_payer" />
                : null
                }
                {has_role(permissions,'ROLE_MANAGER') ?
                    <TextField source="total_encaisse" label="Total encaissé(€)" sortBy="total_encaisse" />
                    : null
                }
                {has_role(permissions,'ROLE_MANAGER') ?
                    <TextField source="total_general" label="Total TTC(€)" sortBy="total_general" />
                    : null
                }

                <TextField source="lastModifiedDate" label="Date" />
                <ShowButton  />

            </Datagrid>
        </List>
    );



}

export default ListCampagne;


const ListActions = (props) => {
    const {
        className,
        exporter,
        filters,
        maxResults,
        permissions,
        ...rest
    } = props;
    const {
        resource,
        displayedFilters,
        filterValues,
        basePath,
        showFilter
    } = useListContext();
    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button'
            })}
        {has_role(permissions,'ROLE_MANAGER') ? <CreateButton basePath={basePath} /> : null}
           
        </TopToolbar>
    );
};

/*
const GuetsiBulkActionButtons = ({ props, selectedIds }) => (
    <Fragment>

        <p style={style}>

            Total : {total}
        </p>

        <p style={style}>

            Montant : {montant}
        </p>
        <p style={style}>

            Frais : {frais}
        </p>

    </Fragment>
);


const ListCampagneAction = (props) => {
    const {
        bulkActions,
        basePath,
        currentSort,
        displayedFilters,
        exporter,
        filters,
        filterValues,
        onUnselectItems,
        resource,
        selectedIds,
        showFilter,
        total,
        data
    } = useListContext();

    return (
        <TopToolbar>
            {bulkActions && React.cloneElement(bulkActions, {
                basePath,
                filterValues,
                resource,
                selectedIds,
                onUnselectItems,
            })}
            {filters && React.cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
            {permissions => has_role(permissions,'ROLE_MANAGER') ? <CreateButton basePath={basePath} /> : null}

        </TopToolbar>
    );

};

*/
